import React from "react";

import { FormButton } from "components";

import HorarioRangos from "../rangos/HorarioRangos";

/**
 * Mete la gestión de Rangos adentro del modal de Horarios y le pone el pie.
 *
 * Este es el ÚNICO lugar desde el que se llega a los rangos: no hay pantalla suelta ni
 * ruta propia, porque una franja no significa nada sin el horario del que cuelga.
 *
 * No le pasa el `service`: la vista lo saca de `useService()`, que funciona igual acá
 * adentro porque el portal del modal conserva el árbol de React y con él el contexto
 * del Outlet.
 */
export default function RangoModal({ horario, onCambio, closeModal }) {
    return (
        <>
            <HorarioRangos horario={horario} onCambio={onCambio} />
            <FormButton oneButton closeButtonText="Cerrar" onCloseModal={closeModal} />
        </>
    );
}
